document.addEventListener('DOMContentLoaded', function() {
    // Reusable function to add/remove '-success' class based on value
    function checkSuccessClass(element) {
        if (element.value !== "") {
            element.classList.add('-success');
        } else {
            element.classList.remove('-success');
        }
    }

    // Function to check all inputs and selects inside the elements with 'js-productFieldCheck'
    function checkFields() {
        const productFields = document.querySelectorAll('.js-productFieldCheck input, .js-productFieldCheck select');
        
        productFields.forEach(function(field) {
            if (!field.classList.contains('-hidden')) {
                checkSuccessClass(field);  // Check on page load
                
                if (field.tagName.toLowerCase() === 'input') {
                    // Use 'input' event for input elements
                    field.addEventListener('input', function() {
                        checkSuccessClass(this);  // Check on input
                    });
                } else if (field.tagName.toLowerCase() === 'select') {
                    // Use 'change' event for select elements
                    field.addEventListener('change', function() {
                        checkSuccessClass(this);  // Check on change
                    });
                }
            }
        });
    }

    // Select all variation select fields inside the variations form
    const variationSelects = document.querySelectorAll('form.variations_form .variations select');

    // Apply check on page load for each variation select field
    variationSelects.forEach(function(select) {
        checkSuccessClass(select);  // Check on page load
        select.addEventListener('change', function() {
            checkSuccessClass(this);  // Check on change
        });
    });

    // Check on page load for all fields inside 'js-productFieldCheck'
    checkFields();
});
